// https://github.com/junipersquare/main/blob/7bbfc9872d67c0b653f1d7388f14472df14b2703/jsq/client/src/common/utils/stringUtils/index.ts#L124

export const oxfordComma = (items: string[]) => {
  if (items.length === 0) {
    return "";
  }
  if (items.length === 1) {
    return items[0];
  }
  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`;
  }

  const itemsCopy = [...items];
  const last = itemsCopy.pop();
  const first = itemsCopy.join(", ");
  return `${first}, and ${last}`;
};
